import Media from "webutils/media/media";

export default Media;
